import Vue from "vue";
const state = () => ({
    pending: false,
});

const mutations = {
    START_PENDING_STATE(state) {
        state.pending = true;
    },

    END_PENDING_STATE(state) {
        state.pending = false;
    },
};

const actions = {
    startPendingState({ commit }) {
        commit("START_PENDING_STATE");
    },

    endPendingState({ commit }) {
        commit("END_PENDING_STATE");
    },
};

const getters = {
    pending: (state) => {
        return state.pending;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};